import cx from "classnames";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { useAppService } from "../hooks/use-app-service";
import { useSocketGroupChatListener } from "../hooks/user-socket-group-chat-listerner.hook";
import { mixPanel } from "../_config/mixpanel.config";
import { COMMUNITY_EVENTS_PAGE_ROUTE } from "../_pages/events-page";
import {
  getGroupPageRouteFromSlug,
  getSectionPageRouteFromSlug,
} from "../_pages/group/index";
import { CommunityService, GroupService } from "../_service";
import AnalyticsService, { EventType } from "../_service/analytics-service";
import { NotificationService } from "../_service/notification.service";
import { store } from "../_store";
import {
  getRealtimeSectionNotificationCount,
  IncreaseGroupChatBadgeCount,
} from "../_store/realtime-section-notification.store/realtime-section-notification.action";
import {
  removeActiveGroup,
  setActiveGroup,
  setGroups,
} from "../_store/_actions/group.actions";
import { setNotifications } from "../_store/_actions/notification.actions";
import { setPersonalGroup } from "../_store/_actions/personal-group.actions";
import { ActionModal } from "./action-modal.component";
import I18 from "./atoms/i18";
import CommunityLinks from "./community-links.component";
import ExpiredActionPreventor from "./community/community-expired-action-preventor.component";
import { CreateGroupModal } from "./group/create-group-modal.component";
import { CreateSectionModal } from "./group/create-section-modal.component";
import IconMenu2, { ActionType } from "./icon-menu-2.component";
import ModalPortal from "./Portal";
import SidebarGroupsListShimmerComponent from "./shimmers/sidebar/sidebar-group-list-shimmer.component";
import EmbeddedSectionLinks from "./sidebar/embedded-section-links.component";
import UIcon from "./uicon-component";

function SidebarComponent({
  user,
  community,
  realtimeSectionNotificationCount,
  groups,
  group,
  setGroup,
  activeGroup,
  personalGroup,
  addToast = (e) => {},
  notifications = [],
  setNotifications = (e) => {},
  updateGroups,
  setActiveGroup,
  setPersonalGroup,
  history,
  isSidebarOpen = false,
  setIsSidebarOpen = (e) => {},
  isCreateGroupModalVisible,
  setIsCreateGroupModalVisible,
  isCreateSectionModalVisible,
  setIsCreateSectionModalVisible,
  setIsPersonalSpace,
  isPersonalSpace,
  updateActiveGroup = (e) => {},
  sidebarIgnoresCommunitySwitcher = false,
  isLoadingGroups,
  socket,
  // tab
  activeTab,
  setActiveTab,
  // context
}) {
  const { analyticsService } = useAppService();

  const [currentGroupId, setCurrentGroupId] = useState(
    window.location.pathname.split("/").pop()
  );
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const [isEditGroupModalVisible, setIsEditGroupModalVisible] = useState(false);

  const [isLeaveModalVisible, setIsLeaveModalVisible] = useState(false);

  const [isLeaveSectionVisible, setIsLeaveSectionVisible] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [isEditingTab, setIsEditingTab] = useState(false);

  const [currentActiveGroup, setCurrentActiveGroup] = useState({});

  const [currentActiveSection, setCurrentActiveSection] = useState({});
  const [isGroupClicked, setIsGroupClicked] = useState(false);
  const [joinedGroups, setJoinedGroups] = useState([]); // dont filter for now

  // Personal Group
  // const [personalGroup, setPersonalGroup] = useState({});

  // get current route
  const currentRoute = window.location.search;

  const activePath = document.location.pathname;
  // get selected tab id
  const sp = new URLSearchParams(window.location.search);

  const selectedTabId = sp.get("tab");

  // const lang  = useLang();

  // listen for tab change
  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      // check if part of group, (just check the last part of the url)
      setCurrentGroupId(window.location.pathname.split("/").pop());
    });

    return () => {
      unlisten();
    };
  }, [history]);

  //get realtime section notification badges
  useEffect(() => {
    store.dispatch(getRealtimeSectionNotificationCount());
  }, [user?.id]);

  // Listen for all new messages in realtime section and update the badge count
  useSocketGroupChatListener(socket, IncreaseGroupChatBadgeCount);

  useEffect(() => {
    setJoinedGroups(groups);
  }, [groups]);
  // filter out only joined groups
  // const joinedGroups = groups.filter(g => g.joinStatus === "joined");
  // const joinedGroups = groups; // dont filter for now

  // const activeTabModel = activeGroup ? activeGroup.tabs.find(t => t.id === selectedTabId) : null;

  const [draggingGroupIndex, setDraggingGroupIndex] = useState(null);

  // useEffect(() => {
  //     onPageLoad()
  // }, []);

  // const onPageLoad = () => {
  //     GroupService.getPersonalGroup(user)
  //         .then(response => {
  //             setPersonalGroup(response.group);
  //         })
  //         .catch(err => {
  //             console.log(err);
  //             addToast('Personal group could not be loaded!', '', 'danger');
  //         });
  // }

  const onSubmitDelete = () => {
    GroupService.deleteGroup(user, currentActiveGroup.id)
      .then((response) => {
        // remove group
        setGroup(response.group);
        addToast("Group deleted!");
        updateActiveGroup(response.group);
        setIsDeleteModalVisible(false);
        history.push("/");
      })
      .catch((err) => {
        console.log(err);
        setIsDeleteModalVisible(false);
        addToast("Group could not be deleted!", "", "danger");
      });
  };

  const onSubmitSectionDelete = () => {
    // delete section
    setIsLoading(true);
    GroupService.deleteGroupTab(
      user,
      currentActiveGroup.id,
      currentActiveSection.id
    )
      .then(({ group }) => {
        // update the group
        setIsLoading(false);
        // resetFormAndClose();
        addToast("Channel deleted!", "", "success");
        setIsDeleteModalVisible(false);
        if (currentActiveGroup.id === personalGroup.id) {
          setPersonalGroup(group);
          history.push(`/personal-space?tab=${currentActiveGroup.tabs[0].id}`);
        } else {
          setGroup(group);
          history.push(`/group/${currentActiveGroup.id}`);
        }
      })
      .catch((error) => {
        console.log({ error });
        addToast("Unable to delete channel!", "", "danger");
        setIsLoading(false);
        setIsDeleteModalVisible(false);
      });
  };

  const onSubmitLeave = () => {
    setIsLoading(true);
    GroupService.leaveGroup(user, currentActiveGroup.id)
      .then((response) => {
        // update group
        setGroup(response.group);
        // set loading to false
        setIsLoading(false);
        setIsLeaveModalVisible(false);
        addToast("Group left!", "", "success");
        AnalyticsService.logEvent(EventType.Group.name, EventType.Group.leave);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsLeaveModalVisible(false);
        console.log(error);
        addToast("Unable to leave group.", "", "danger");
      });
  };

  const goToPage = (id) => {
    let activeGroup = groups ? groups.find((t) => t.id === id) : null;
    setCurrentActiveGroup(activeGroup);
    history.push(`/group/${id}`);
    setIsGroupClicked(true);
  };

  const goToSection = async (id) => {
    const activeGroup = groups.find((element) => {
      return element.tabs.find((tb) => tb.id == id);
    });
    const activeSection = activeGroup.tabs.find((element) => element.id === id);
    await setCurrentActiveGroup(activeGroup);
    await setCurrentActiveSection(activeSection);
    // history.push(`/group/${activeGroup.id}?tab=${id}`);
    history.push(getSectionPageRouteFromSlug(group, activeSection));
    setIsGroupClicked(false);
  };

  const onGroupDragEnd = async (e, index) => {
    // logic to drag the index somewhere else
    // do nothing, if dragging group index in the same place
    if (draggingGroupIndex === index || draggingGroupIndex === null) {
      console.log("no drag occurred!");
      return;
    }

    if (!community || community.myRole !== "admin") {
      return;
    }

    try {
      // Get copy of groups
      const groupList = Array.from(groups);

      // Get the item which is being dragged
      const movedItem = groupList.splice(draggingGroupIndex, 1)[0];

      // Get the remaining items
      const remainingItems = groupList.filter((g) => g.id !== movedItem.id);

      // Insert the item in the new position
      const reorderedItems = [
        ...remainingItems.slice(0, index),
        movedItem,
        ...remainingItems.slice(index),
      ];

      // create an array of objects with groupId,groupName and sortOrder
      const sortOrder = reorderedItems.map((g, i) => {
        return {
          groupId: g.id,
          groupName: g.name,
          sortOrder: i + 1,
        };
      });

      // save order in a map with groupId as key and sortOrder as value
      const orderMap = sortOrder.reduce((acc, value) => {
        acc[value.tabId] = value.sortOrder;
        return acc;
      }, {});

      // hit the api to update the sortOrder
      await CommunityService.sortCommunityGroups(user, community.id, sortOrder);

      // update the groups with map to new sort order
      const newGroups = reorderedItems
        .map((g) => {
          g.sortOrder = orderMap[g.id];
          return g;
        })
        .sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        });
      // remove draggable index
      setDraggingGroupIndex(null);
      // update the store with new groups
      updateGroups(newGroups);
    } catch (error) {
      addToast("Could not perform the action!", "", ToastTypes.danger);
    }
  };
  return (
    <div
      onClick={(e) => {
        setIsSidebarOpen(false);
      }}
      className={cx("Sidebar", {
        open: isSidebarOpen,
        "no-switcher": sidebarIgnoresCommunitySwitcher || !user,
      })}>
      <div className="sidebar-content theme-bg-default select-none rounded p-3">
        <div className="group-link-holder py-4">
          <Link
            to="/?tab=Posts"
            onClick={() => {
              analyticsService.track("home-pressed", {
                sourceLocation: window.location.href
              });
            }}
            className={cx(
              "sidebar-heading-holder flex items-center px-4 py-2 mx-2  rounded cursor-pointer ",
              {
                "theme-bg-primary theme-text-on-primary":
                  currentRoute === "?tab=Posts" ||
                  currentRoute === "?action=autosub",
                "theme-text-heading-1":
                  !(
                    currentRoute !== "?tab=Posts" ||
                    currentRoute !== "?action=autosub"
                  ) ||
                  (currentRoute !== "?tab=Posts" &&
                    currentRoute !== "?action=autosub"),
              }
            )}>
            <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
              <UIcon icon="home" className="text-lg h-7" />
              <span>
                <I18>Home</I18>
              </span>
            </div>
          </Link>

          <Link
            onClick={() => {
              analyticsService.track("explore-group-clicked", {
                sourceLocation: window.location.href
              });
            }}
            to="/?tab=Groups"
            className={cx(
              "sidebar-heading-holder flex items-center px-4 py-2 mx-2 rounded cursor-pointer ",
              {
                "theme-bg-primary theme-text-on-primary":
                  currentRoute === "?tab=Groups",
                "theme-text-heading-1": currentRoute !== "?tab=Groups",
              }
            )}>
            <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
              <UIcon icon="navigation" className="text-lg h-7" />
              <span>
                <I18>Explore Groups</I18>
              </span>
            </div>
          </Link>

          {/* COURSE */}
          {user &&
            community?.configuration &&
            !community.configuration.isExploreCourseDisabled && (
              <Link
                onClick={() => {
                  analyticsService.track("course-clicked", {});
                }}
                to={"/course"}
                className={cx(
                  "sidebar-heading-holder flex items-center px-4 py-2 mx-2 rounded cursor-pointer ",
                  {
                    "theme-bg-primary theme-text-on-primary":
                      activePath.startsWith("/course"),
                    "theme-text-heading-1": !activePath.startsWith("/course"),
                  }
                )}>
                <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
                  <UIcon icon="cube" className="text-lg h-7" />
                  <span>
                    <I18>Course</I18>
                  </span>
                </div>
              </Link>
            )}
          {/* DIRECT  MESSAGES */}

          {/* {user && community && !community.isDirectMessageDisabled ? (
            <Link
              to="/direct-message/users"
              onClick={() => {
                mixPanel.track("direct-message", { CTAButton: "Sidebar" });
              }}
              className={cx(
                "sidebar-heading-holder flex items-center px-4 py-2 mx-2 rounded cursor-pointer theme-text-heading-1"
              )}>
              <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
                <UIcon icon="comment-alt" className="text-lg h-7" />
                <span>
                  {" "}
                  <I18>Direct Message</I18>
                </span>
              </div>
            </Link>
          ) : (
            <></>
          )} */}

          {/* {user ? (
            <div
              onClick={() =>
                history.push(createUserWallPageRoute(user.id, "bookmarks"))
              }
              className={cx(
                "sidebar-heading-holder flex items-center px-4 py-2 mx-2 rounded-md cursor-pointer ",
                {
                  "theme-bg-primary theme-text-on-primary":
                    currentRoute === "?tab=bookmarks",
                  "theme-text-heading-1": currentRoute !== "?tab=bookmarks",
                }
              )}>
              <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
                <UIcon icon="bookmark" className="text-lg h-7" />
                <span>Saved Item</span>
              </div>
            </div>
          ) : (
            <></>
          )} */}
          {user &&
          community?.configuration &&
          !community.configuration.isEventsTabDisabled ? (
            <NavLink
              onClick={() => analyticsService.track("calendar-clicked", {})}
              exact={true}
              strict
              className={cx(
                "sidebar-heading-holder flex items-center px-4 py-2 mx-2 rounded cursor-pointer",
                {
                  "theme-bg-primary theme-text-on-primary":
                    activePath.split("/")[1] === "events",
                  "theme-text-heading-1": activePath.split("/")[1] !== "events",
                }
              )}
              to={COMMUNITY_EVENTS_PAGE_ROUTE}>
              <div className="sidebar-heading font-bold pr-3 space-x-3 flex items-center ">
                <UIcon icon="calendar" className="text-lg h-7" />
                <span>
                  <I18>Calendar</I18>
                </span>
              </div>
            </NavLink>
          ) : (
            <></>
          )}

          {/* Navlinks for admin and mobile view */}
          {community && community?.configuration?.showCommunityLinksInHeader ? (
            <CommunityLinks navLinkMode />
          ) : (
            <></>
          )}

          {/* embedded section link */}
          <EmbeddedSectionLinks />

          {/* create group button */}
          <div className="sidebar-heading-holder flex items-center justify-between pl-6 py-3">
            <div className="sidebar-heading uppercase theme-text-heading-1 font-semibold">
              <I18>Groups</I18>
            </div>
            {community && community.myRole === "admin" ? (
              <ExpiredActionPreventor>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setIsCreateGroupModalVisible(true);
                  }}
                  className="p-4 hover:shadow cursor:pointer flex items-center place-content-center h-10 w-10 rounded-full cursor-pointer">
                  <div className="border flex items-center p-1 h-4 w-4  rounded theme-border-subtitle-1 place-content-center">
                    <UIcon icon="plus-small" className="text-sm select-none" />
                  </div>
                </div>
              </ExpiredActionPreventor>
            ) : (
              <></>
            )}
          </div>

          {/* group links */}
          <div className="group-links px-2">
            {/* group list */}
            {joinedGroups.length === 0 && !isLoadingGroups ? (
              <div className="p-4 theme-text-primary border border-dashed theme-border-primary">
                {community && community.myRole === "admin" ? (
                  <I18>
                    No groups here, please use + to create a new one, or join
                    one see them here.
                  </I18>
                ) : (
                  <I18>Please join a group to see them here</I18>
                )}
              </div>
            ) : // <div className="p-4 text-blue-300 border border-dashed border-blue-300">
            //     {
            //         community && community.myRole === "admin" ? "No groups here, please use + to create a new one, or join one see them here." : "Please join a group to see them here"
            //     }
            // </div>
            joinedGroups.length > 0 ? (
              joinedGroups.map((group, index) => (
                <GroupButton
                  key={group.id}
                  group={group}
                  community={community}
                  notifications={notifications}
                  setNotifications={setNotifications}
                  currentGroupId={currentGroupId}
                  realtimeSectionNotificationCount={
                    realtimeSectionNotificationCount
                  }
                  selectedTabId={selectedTabId}
                  user={user}
                  setIsCreateSectionModalVisible={
                    setIsCreateSectionModalVisible
                  }
                  setIsCreateGroupModalVisible={setIsCreateGroupModalVisible}
                  setIsEditGroupModalVisible={setIsEditGroupModalVisible}
                  setIsDeleteModalVisible={setIsDeleteModalVisible}
                  setIsLeaveModalVisible={setIsLeaveModalVisible}
                  setIsEditingTab={setIsEditingTab}
                  setIsPersonalSpace={setIsPersonalSpace}
                  goToPage={goToPage}
                  goToSection={goToSection}
                  draggable={community.myRole === "admin"}
                  onDragStart={(e) => {
                    // logic to save current group index
                    setDraggingGroupIndex(index);
                  }}
                  onDrop={(e) => {
                    onGroupDragEnd(e, index);
                  }}
                  addToast={addToast}
                  groups={groups}
                  updateGroups={updateGroups}
                />
              ))
            ) : (
              <SidebarGroupsListShimmerComponent />
            )}
          </div>
          {/* personal space */}
          {/* <SidebarSubMenu setCurrentActiveGroup={setCurrentActiveGroup} setCurrentActiveSection={setCurrentActiveSection} setIsGroupClicked={setIsGroupClicked} setIsDeleteModalVisible={setIsDeleteModalVisible} setIsEditingTab={setIsEditingTab} setIsPersonalSpace={setIsPersonalSpace} setIsCreateSectionModalVisible={setIsCreateSectionModalVisible} /> */}
          {/* direct messages */}
          {/* {user && community && !community.isDirectMessageDisabled ? (
            <SidebarDirectMessagesSubMenu />
          ) : (
            <></>
          )} */}
        </div>
        {/* edit group modal*/}
        {currentActiveGroup && isEditGroupModalVisible ? (
          <ModalPortal openPortal={isEditGroupModalVisible}>
            <CreateGroupModal
              group={currentActiveGroup}
              updateGroup={(currentActiveGroup) => {
                addToast("Group updated!", "", "success");
                setGroup(currentActiveGroup);
              }}
              active={isEditGroupModalVisible}
              setActive={setIsEditGroupModalVisible}
            />
          </ModalPortal>
        ) : null}
        {/* edit tab model */}
        {isEditingTab ? (
          <ModalPortal openPortal={isEditingTab}>
            <CreateSectionModal
              user={user}
              activeGroup={currentActiveGroup}
              personalGroup={currentActiveGroup}
              activeTab={currentActiveSection}
              active={isEditingTab}
              isPersonalSpace={isPersonalSpace}
              setActive={setIsEditingTab}
              updateActiveGroup={setGroup}
              updatePersonalActiveGroup={setPersonalGroup}
            />
          </ModalPortal>
        ) : (
          <></>
        )}
        {/* Delete/Leave tab/group modal */}
        {isGroupClicked ? (
          <ModalPortal
            openPortal={
              currentActiveGroup && currentActiveGroup.myRole !== "admin"
                ? isLeaveModalVisible
                : isDeleteModalVisible
            }>
            <ActionModal
              active={
                currentActiveGroup && currentActiveGroup.myRole !== "admin"
                  ? isLeaveModalVisible
                  : isDeleteModalVisible
              }
              setActive={
                currentActiveGroup && currentActiveGroup.myRole !== "admin"
                  ? setIsLeaveModalVisible
                  : setIsDeleteModalVisible
              }
              onSubmit={
                currentActiveGroup && currentActiveGroup.myRole !== "admin"
                  ? onSubmitLeave
                  : onSubmitDelete
              }
              header={`${
                currentActiveGroup && currentActiveGroup.myRole !== "admin"
                  ? "Leave"
                  : "Delete"
              } Group`}
              title={`Are you sure you want to ${
                currentActiveGroup && currentActiveGroup.myRole !== "admin"
                  ? "leave"
                  : "delete"
              } the group?`}
              isLoading={isLoading}
              btnColor="red"
            />
          </ModalPortal>
        ) : (
          <ModalPortal openPortal={isDeleteModalVisible}>
            <ActionModal
              active={isDeleteModalVisible}
              setActive={setIsDeleteModalVisible}
              onSubmit={onSubmitSectionDelete}
              header="Delete Channel"
              title="Are you sure you want to delete the Channel?"
              isLoading={isLoading}
              btnColor="red"
            />
          </ModalPortal>
        )}
        {/* community links */}
        <div className="my-6"></div>
        {community &&
        (!community?.configuration?.showCommunityLinksInHeader ||
          community.myRole === "admin") ? (
          <CommunityLinks hideOnMobile />
        ) : (
          <></>
        )}
        {/* powered by */}
        {community?.configuration?.showPoweredByPensil ? (
          <div className="my-6 text-lg px-6 flex">
            <a
              className="hover:text-blue-500 theme-text-subtitle-1 cursor-pointer"
              href="https://www.pensil.in"
              target="__blank">
              <span>
                <I18>Powered by</I18>
              </span>{" "}
              <span className="font-bold">Pensil</span>
            </a>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

function GroupButton({
  group = null,
  community = null,
  realtimeSectionNotificationCount,
  notifications = [],
  setNotifications = (e) => {},
  currentGroupId = null,
  selectedTabId = null,
  user = null,
  setIsCreateSectionModalVisible = (e) => {},
  setIsEditGroupModalVisible = (e) => {},
  setIsDeleteModalVisible = (e) => {},
  setIsLeaveModalVisible = (e) => {},
  setIsEditingTab = (e) => {},
  setIsPersonalSpace = (e) => {},
  goToPage = (e) => {},
  goToSection = (e) => {},
  draggable = false,
  onDragStart = (e) => {},
  onDrop = (e) => {},
  addToast = (e) => {},
  groups = [],
  updateGroups = (e) => {},
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  // const [isHidden, setIsHidden] = useState(true);

  const isExpandedValue =
    !community?.configuration?.collapseSidebarGroupLinks ?? true;

  useEffect(() => {
    setIsExpanded(isExpandedValue);
  }, [isExpandedValue]);

  const active =
    group &&
    (group.id === currentGroupId ||
      (group.meta && group.meta.slug === currentGroupId)) &&
    !selectedTabId;

  const [draggingTabIndex, setDraggingTabIndex] = useState(null);

  const { analyticsService } = useAppService();

  const onGroupSectionDragEnd = async (e, index) => {
    // logic to drag the index somewhere else
    // do nothing, if dragging group index in the same place
    if (draggingTabIndex === index || draggingTabIndex === null) {
      addToast(
        "Channel can only be reordered within the group!",
        "",
        ToastTypes.warning
      );
      console.log("no drag occurred!!");
      return;
    }

    if (!community || community.myRole !== "admin") {
      console.log("not admin");
      return;
    }

    try {
      // Get copy of sections
      const sections = Array.from(group.tabs);

      // Get the item which is being dragged
      const movedItem = sections.splice(draggingTabIndex, 1)[0];

      // Get the remaining items
      const remainingItems = sections.filter((tab) => tab.id !== movedItem.id);

      // Insert the item in the new position
      const reorderedItems = [
        ...remainingItems.slice(0, index),
        movedItem,
        ...remainingItems.slice(index),
      ];

      // create an array of objects with tabId and sortOrder
      const sortOrder = reorderedItems.map((g, i) => {
        return {
          tabId: g.id,
          sortOrder: i + 1,
        };
      });

      // save order in a map with tabId as key and sortOrder as value
      const orderMap = sortOrder.reduce((acc, value) => {
        acc[value.tabId] = value.sortOrder;
        return acc;
      }, {});

      // hit the api to update the sortOrder
      await CommunityService.sortCommunityGroupTabs(
        user,
        community.id,
        group.id,
        sortOrder
      );

      // update the groups with map to new sort order for group.tab
      const newGroups = groups.map((g) => {
        if (g.id === group.id) {
          g.tabs = g.tabs
            .map((t) => {
              return {
                ...t,
                sortOrder: orderMap[t.id],
              };
            })
            .sort((a, b) => {
              return a.sortOrder - b.sortOrder;
            });
        }
        return g;
      });
      // remove draggable index
      setDraggingTabIndex(null);
      // update the store with new groups
      updateGroups(newGroups);
    } catch (error) {
      addToast("Could not perform the action!", "", ToastTypes.danger);
    }
  };
  return (
    <div
      key={group.id}
      className={cx("GroupLinkButton items-center mb-3", {
        expanded: isExpanded,
      })}>
      {/* lock icon */}

      {/* expander */}

      {/* link */}
      <Link
        key={group.id}
        to={getGroupPageRouteFromSlug(group)}
        draggable={draggable}
        onDragStart={onDragStart}
        onClick={() => {
          analyticsService.track("group-selected-sidebar", {
            groupType: group.groupType
          })
        }}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDrop={onDrop}
        className={cx("GroupLink flex items-center place-content-between", {
          "theme-bg-primary theme-text-on-primary": active,
          "theme-text-heading-1 hover:theme-bg-default": !active,
        })}>
        <div>
          <span className="">
            <span
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsExpanded(!isExpanded);
              }}>
              {["closed-free", "closed-paid"].includes(group.groupType) ? (
                <UIcon icon="lock" className="text-sm" />
              ) : (
                <></>
              )}
              <UIcon
                icon={`${isExpanded ? "caret-down" : "caret-right"}`}
                className="text-sm"
              />
            </span>
            <span className="group-name ml-2">
              {group.name.length >= 22
                ? group.name.substring(0, 19) + "..."
                : group.name}
            </span>
          </span>
        </div>
        {/* more options */}
        <div className="GroupEllipsisIcon">
          <IconMenu2
            className="text-sm h-3.5 hover:shadow-none"
            onClick={() => goToPage(group.id)}
            actions={[
              {
                // Show Add Section Option
                icon: "add",
                label:
                  ["admin"].includes(group.myRole) &&
                  !CommunityService.checkIfCommunityActionShouldBeDisabled(
                    community
                  )
                    ? "Add Channel"
                    : "",
                onClick: (e) => {
                  e.preventDefault();
                  setIsCreateSectionModalVisible(true);
                },
              },
              {
                // Show Edit Group Option
                icon: "edit",
                label: ["admin"].includes(group.myRole) ? "Edit group" : null,
                onClick: (e) => {
                  e.preventDefault();
                  setIsEditGroupModalVisible(true);
                },
              },
              {
                // Show Leave Group Option
                icon: "sign-out",
                label:
                  group.myRole !== "admin" && group.joinStatus !== "not-joined"
                    ? "Leave Group"
                    : null,
                onClick: (e) => {
                  e.preventDefault();
                  setIsLeaveModalVisible(true);
                },
                actionType: ActionType.alert,
              },
              {
                // Show Delete Group Option
                icon: "trash",
                label: ["admin"].includes(group.myRole) ? "Delete group" : null,
                onClick: (e) => {
                  e.preventDefault();
                  setIsDeleteModalVisible(true);
                },
                actionType: ActionType.alert,
              },
            ]}
          />
        </div>
      </Link>
      {/* group tabs */}
      {isExpanded &&
        group.tabs.map((tab, index) => {
          const unreadNotificationIds = getUncheckedNotificationIdsForSection(
            notifications,
            tab.id
          );

          return (
            <React.Fragment key={tab.id}>
              {!["admin", "moderator"].includes(group.myRole) &&
              !tab?.isJoined &&
              tab?.isPrivate ? null : (
                <GroupTabButton
                  community={community}
                  realtimeSectionNotificationCount={
                    realtimeSectionNotificationCount
                  }
                  group={group}
                  user={user}
                  tab={tab}
                  key={tab.id}
                  notifications={notifications}
                  selectedTabId={selectedTabId}
                  goToSection={goToSection}
                  setIsEditingTab={setIsEditingTab}
                  setIsPersonalSpace={setIsPersonalSpace}
                  setIsDeleteModalVisible={setIsDeleteModalVisible}
                  draggable={community.myRole === "admin"}
                  onDragStart={(e) => {
                    setDraggingTabIndex(index);
                  }}
                  onDrop={(e) => {
                    onGroupSectionDragEnd(e, index);
                  }}
                  unreadNotificationIds={unreadNotificationIds}
                />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
}
/**
 * Section Button
 * @param {*} props
 */
function GroupTabButton({
  tab,
  notifications,
  community,
  realtimeSectionNotificationCount,
  group,
  user,
  selectedTabId,
  goToSection,
  setIsEditingTab,
  setIsPersonalSpace,
  setIsDeleteModalVisible,
  draggable,
  onDragStart,
  onDrop,
}) {
  const unreadNotificationIds = getUncheckedNotificationIdsForSection(
    notifications,
    tab.id
  );

  const currentSectionSlug = window.location.pathname.includes("/s/")
    ? window.location.pathname.split("/s/").reverse()[0]
    : null;

  const currentGroupSlug = window.location.pathname.includes("/g/")
    ? window.location.pathname.match("/g/(.+?)/s/")
    : null;

  const isActive =
    selectedTabId === tab.id ||
    (currentSectionSlug === tab.meta?.slug &&
      currentGroupSlug &&
      currentGroupSlug[1] === group.meta.slug);

  const { analyticsService } = useAppService();

  return (
    <Link
      key={tab.id}
      to={getSectionPageRouteFromSlug(group, tab)}
      onClick={(e) => {
        // if we have unreadCOunt call api and update notifications
        if (unreadNotificationIds.length > 0) {
          NotificationService.markSelectedNotificationsAsReceived(
            user,
            unreadNotificationIds
          )
            .then(({ ids }) => {
              // update old notification
              setNotifications(
                notifications.map((n) => {
                  if (ids.includes(n.id)) {
                    n.isReceived = true;
                  }
                  return n;
                })
              );
            })
            .catch((error) => {
              console.log(
                "failed to mark notification as received from sidebar",
                { error }
              );
            });
        }
        analyticsService.track("section-selected-sidebar", {
          sectionType: tab.sectionType
        })
      }}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDrop={onDrop}
      className={cx("group-link-tab items-center", {
        "theme-bg-primary theme-text-on-primary": isActive,
        "theme-text-subtitle-1 hover:theme-bg-default": !isActive,
      })}>
      <div
        className={cx("emoji", {
          hash: !tab.emoji || tab.emoji === "#",
        })}>
        {tab.emoji ? tab.emoji : "#"}
      </div>
      <SidebarTooltip label={tab.name.length > 30 ? tab.name : ""}>
        {tab.name.length > 30 ? tab.name.substr(0, 30) + "..." : tab.name}
      </SidebarTooltip>
      <div className="SectionEllipsisIcon">
        {group.myRole === "admin" ? (
          <IconMenu2
            className="text-sm h-3.5 hover:shadow-none"
            onClick={() => goToSection(tab.id)}
            actions={[
              {
                // show edit section button
                label: "Edit Channel",
                icon: "edit",
                onClick: (e) => {
                  e.preventDefault();
                  setIsEditingTab(true);
                  setIsPersonalSpace(false);
                },
              },
              {
                // show delete section button
                icon: "trash",
                label: "Delete Channel",
                actionType: ActionType.alert,
                onClick: (e) => {
                  e.preventDefault();
                  setIsDeleteModalVisible(true);
                  setIsPersonalSpace(false);
                },
              },
            ]}
          />
        ) : (
          <></>
        )}
      </div>
      {unreadNotificationIds.length > 0 ? (
        <div className="theme-bg-primary p-[10px] theme-text-on-primary h-[16px] w-[16px] text-xxs font-thin justify-center items-center flex rounded">
          {unreadNotificationIds.length}
        </div>
      ) : (
        <></>
      )}
      {realtimeSectionNotificationCount?.count && (
        <>
          {Object.entries(realtimeSectionNotificationCount.count).map(
            ([id, count], index) => {
              if (tab.id === id) {
                return (
                  <div
                    key={index}
                    className="theme-bg-primary  p-[10px] theme-text-on-primary h-[16px] w-[16px] justify-center items-center text-xxs font-thin flex rounded">
                    {count}
                  </div>
                );
              }
              return null;
            }
          )}
        </>
      )}
    </Link>
  );
}
function SidebarTooltip({ children, label }) {
  const rotate = {
    top: "rotate(90deg)",
  };

  return (
    <div className="tooltip font-light overflow-ellipsis overflow-hidden">
      {children}
      {label && (
        <div className="invisible opacity-0 label absolute flex flex-col items-center transition-all duration-700 transform -translate-y-2 mb-10 bottom-0 left-0 right-0">
          <span className="m-2 relative z-10 p-2 text-xs leading-none theme-bg-heading-1 theme-text-background whitespace-no-wrap shadow-md w-2/3 rounded delay-1000 ease-linear">
            <div className="whitespace-normal text-center flex">{label}</div>
            <div className="absolute flex items-center w-full left-0 -bottom-2 place-content-center">
              <div style={{ transform: rotate.top }}>
                <UIcon icon="play" solid className="theme-text-default" />
              </div>
            </div>
          </span>
        </div>
      )}
    </div>
  );
}

function getUncheckedNotificationIdsForSection(notifications = [], sectionId) {
  return notifications
    .filter((n) => n.post && n.post.tabId === sectionId && !n.isReceived)
    .map((n) => n.id);
}

const mapStateToProps = (state) => ({
  user: state.auth,
  community: state.community,
  groups: state.groups,
  isLoadingGroups: state.isLoadingGroups,
  group: state.activeGroup,
  realtimeSectionNotificationCount:
    state.realTimeSectionCountReducer.realtimeSectionNotificationCount,
  notifications: state.notifications,
  activeTab: state.activeTab,
  activePersonalGroup: state.activePersonalGroup,
  personalGroup: state.personalGroup,
  socket: state.socket,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateGroups: setGroups,
      setNotifications: setNotifications,
      updateActiveGroup: removeActiveGroup,
      setGroup: setActiveGroup,
      setPersonalGroup: setPersonalGroup,
    },
    dispatch
  );

const Sidebar = withToast(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(SidebarComponent))
);

export default Sidebar;
